/* eslint-disable no-await-in-loop */
import { getValidUrl } from "common/components/MdfDialog/constants"

export const KEYS = {
  CRM: "CRM",
  GEFINTECH: "GEFINTECH",
}

const initFakeProgress = async (setProgressValue: $TSMigrationFixMe) => {
  for (let i = 10; i <= 100; i += 10) {
    await new Promise((res) => setTimeout(res, 100))
    setProgressValue(i)
  }
  await new Promise((res) => setTimeout(res, 1000))
}
export const getDataToSendToExternalApp = (
  empresaNif: $TSMigrationFixMe,
  setShowLoader: $TSMigrationFixMe,
  setInitProgressValue: $TSMigrationFixMe,
  setMessage: $TSMigrationFixMe,
  setProgressValue: $TSMigrationFixMe,
  aplicationKey: $TSMigrationFixMe
) => {
  // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa...
  localStorage.setItem("mercado-facturas-first-time", true)

  const configMdfConnector = {
    action: "set",
    empresaNif,
    token: sessionStorage.getItem("access_token"),
    refreshToken: sessionStorage.getItem("refresh_token"),
    comesFromVuzoon: true,
  }

  setShowLoader(true)
  setInitProgressValue(true)
  setMessage(JSON.stringify(configMdfConnector))
  initFakeProgress(setProgressValue).then(() => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
    window.open(getValidUrl(configMdfConnector)[aplicationKey].url, "_self")
    sessionStorage.clear()
    localStorage.clear()
  })
}
